var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trial-feedback"},[_c('div',{staticClass:"scroll"},[_c('trial-result-basic-info'),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"inner"},[_c('trial-total-average'),_c('trial-visualization'),_c('trial-question-summary')],1),_c('copyright')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }